<template>
    <div class="apprentice-simple-card">
        <design-2021-apprentice-data-table
            class="learning-path-deadlines"
            :items="tableData"
            :fields="studentFields">
            <template #options>
                <b-form-select
                    class="apprentice-primary-select students-filter"
                    v-model="selectedFilter"
                    :options="options">
                </b-form-select>
            </template>

            <template v-slot:cell(action)="data">
                <div class="actions">
                    <b-button
                        class="btn-remove btn-remove-lp-assignment"
                        v-b-tooltip.hover
                        v-if="data.item.assignment"
                        variant="danger-icon-only"
                        :title="$t('learning_path.delete_exercise')"
                        @click="removeAssignment(data.item.id, data.item.signupRecord.lp_assignment_id)">
                    </b-button>
                    <b-button
                        class="btn-add btn-add-lp-assignment"
                        v-if="!data.item.assignment"
                        v-b-tooltip:hover
                        variant="primary-icon-only"
                        :title="$t('learning_path.add_exercise')"
                        @click="openAddAssignment(data.item.id)"></b-button>
                </div>
            </template>
            <template v-slot:cell(backUpAction)="data">
                <div class="actions">
                    <b-button
                        class="btn-remove btn-remove-lp-assignment"
                        v-b-tooltip.hover
                        v-if="data.item.backUpAssignment"
                        variant="danger-icon-only"
                        :title="$t('learning_path.delete_exercise')"
                        @click="removeAssignment(data.item.id, data.item.backUpSignupRecord.lp_assignment_id)">
                    </b-button>
                    <b-button
                        class="btn-add btn-add-lp-assignment"
                        v-if="!data.item.backUpAssignment && data.item.assignment"
                        v-b-tooltip:hover
                        variant="primary-icon-only"
                        :title="$t('learning_path.add_exercise')"
                        @click="openAddAssignment(data.item.id)">
                    </b-button>
                </div>
            </template>
        </design-2021-apprentice-data-table>
        <design-2021-learning-path-deadline-student-add-assignment-modal-component
            ref="add-lp-assignment-modal"
            @addedAssignment="addedAssignment($event)"
            :lp-deadline-in="this.lpDeadlineIn">
        </design-2021-learning-path-deadline-student-add-assignment-modal-component>
    </div>
</template>

<script>
export default {
    name: 'design-2021-learning-path-deadline-student-index-component',
    props: ['lpDeadlineIn', 'studentsIn'],
    data() {
        return {
            lpDeadline: this.lpDeadlineIn,
            students: this.studentsIn,
            studentFields: [
                {
                    key: 'full_name',
                    label: this.$t('common.name'),
                },
                {
                    key: 'assignment',
                    label: this.$t('learning_path.exercise'),
                },
                {
                    key: 'category',
                    label: this.$t('learning_path.work_field'),
                },
                {
                    key: 'action',
                    label: this.$t('common.actions'),
                },
                {
                    key: 'backUpAssignment',
                    label: this.$t('learning_path.backup_assignment'),
                },
                {
                    key: 'backUpCategory',
                    label: this.$t('learning_path.work_field'),
                },
                {
                    key: 'backUpAction',
                    label: this.$t('common.actions'),
                },
            ],
            selectedFilter: 0,
            options: [
                {
                    value: null,
                    text: this.$t('learning_path.choose_filter'),
                    disabled: true,
                },
                {
                    value: 0,
                    text: this.$t('learning_path.all_students'),
                },
                {
                    value: 1,
                    text: this.$t('learning_path.students_with_a_exercise'),
                },
                {
                    value: 2,
                    text: this.$t('learning_path.students_without_a_exercise'),
                },
            ],
        };
    },
    computed: {
        tableData() {
            let students = this.students.map((student) => {
                const signupRecord = student.lp_signup_records[0] ? student.lp_signup_records[0] : null;
                const backUpSignupRecord = student.lp_signup_records[1] ? student.lp_signup_records[1] : null;
                return {
                    id: student.id,
                    full_name: student.full_name,
                    signupRecord: signupRecord,
                    assignment: signupRecord ? signupRecord.lp_assignment.name : null,
                    category: signupRecord ? signupRecord.lp_assignment.lp_category.name : null,
                    backUpSignupRecord: backUpSignupRecord,
                    backUpAssignment: backUpSignupRecord ? backUpSignupRecord.lp_assignment.name : null,
                    backUpCategory: backUpSignupRecord ? backUpSignupRecord.lp_assignment.lp_category.name : null,
                };
            });

            switch (this.selectedFilter) {
                case 0:
                    return students;

                case 1:
                    return students.filter((student) => student.assignment);

                case 2:
                    return students.filter((student) => !student.assignment);

                default:
                    return students;
            }
        },
    },
    methods: {
        addedAssignment(data) {
            this.students = this.students.map((student) => {
                if (student.id === data[0].user_id) {
                    student.lp_signup_records = data;
                    this.alert.success();
                }
                return student;
            });
        },
        removeAssignment(studentId, assignmentId) {
            this.alert
                .confirm(
                    this.$t('learning_path.delete_exercise'),
                    this.$t('learning_path.are_you_sure_you_want_to_delete_this_exercise'),
                )
                .then((confirm) => {
                    if (!confirm) {
                        return;
                    }
                    this.axios
                        .delete(
                            this.routes.lpDeadlineRemoveStudentAssignment(
                                this.lpDeadline.lp_deadline_series_id,
                                this.lpDeadline.id,
                                studentId,
                                assignmentId,
                            ),
                        )
                        .then(
                            (response) => {
                                this.alert.success();
                                this.students = this.students.filter((student) => {
                                    if (student.id === studentId) {
                                        const recordIdIndex = student.lp_signup_records.findIndex(
                                            (record) => record.lp_assignment_id === assignmentId,
                                        );
                                        if (recordIdIndex > -1) {
                                            student.lp_signup_records.splice(recordIdIndex, 1);
                                        }
                                        return student;
                                    } else {
                                        return student;
                                    }
                                });
                            },
                            (error) => {
                                this.alert.ajaxError(error);
                            },
                        );
                });
        },
        openAddAssignment(studentId) {
            this.$refs['add-lp-assignment-modal'].show(studentId);
        },
    },
};
</script>

<style scoped lang="scss">
.students-filter {
    margin-bottom: 0;
}

@media (min-width: map-get($grid-breakpoints, 'sm')) {
    .learning-path-deadlines ::v-deep {
        .apprentice-table-header {
            flex-direction: row;

            .apprentice-table-filters {
                flex: 0 0 auto;
                margin-bottom: 0;
            }

            .apprentice-data-table-actions {
                flex: 0 0 auto;
                justify-self: flex-end;
            }
        }
    }
}
</style>
